import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit, OnDestroy {
    @Input() collapsed: boolean = false;
    @Input() collapsible: boolean = false;
    @Input() tabsHidden: boolean = false;
    @Output() toggleSidebar = new EventEmitter<void>();
    @Output() toggleTabs = new EventEmitter<void>();

    public admin: boolean = false;
    public projectCatalogAllowed: boolean = false;
    public projectCatalogBrowsable: boolean = false;
    public activitySummary: any = null;
    public activitySummaryLoading: boolean = false;
    public contextLoaded: boolean = false;
    public collapsedTooltip: any = {
        visible: false,
        label: '',
        top: 0,
        left: 0
    };
    private readonly accountTabStorageKey: string = 'reviewops.account.active-tab.v1';
    private readonly accountTabs: string[] = ['profile', 'codex', 'activity', 'ranking', 'guide'];
    private collapsedTooltipTarget: HTMLElement | null = null;
    private contextRequestSeq: number = 0;
    private destroyed: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadContext();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.contextRequestSeq += 1;
    }

    public async loadContext() {
        const requestSeq = ++this.contextRequestSeq;
        const { code, data } = await wiz.call('load_context');
        if (this.destroyed || requestSeq !== this.contextRequestSeq) return;
        this.contextLoaded = true;
        if (code !== 200 || !data) {
            await this.service.render();
            return;
        }
        this.admin = !!data.is_admin;
        this.projectCatalogAllowed = !!data.can_use_project_catalog;
        this.projectCatalogBrowsable = !!data.can_browse_project_catalog;
        this.activitySummary = data.activity_summary || null;
        if (data.user) {
            this.service.auth.session = Object.assign({}, this.service.auth.session || {}, data.user);
        }
        this.activitySummaryLoading = this.canViewActivitySummary() && !this.activitySummary;
        await this.service.render();
        if (this.activitySummaryLoading) this.loadActivitySummary();
    }

    private async loadActivitySummary() {
        const requestSeq = ++this.contextRequestSeq;
        try {
            const { code, data } = await wiz.call('load_context', { include_activity_summary: '1' });
            if (this.destroyed || requestSeq !== this.contextRequestSeq) return;
            if (code === 200 && data) this.activitySummary = data.activity_summary || null;
        } catch (e) {
            if (this.destroyed || requestSeq !== this.contextRequestSeq) return;
        }
        if (this.destroyed || requestSeq !== this.contextRequestSeq) return;
        this.activitySummaryLoading = false;
        await this.service.render();
    }

    public isActive(link: string) {
        if (link.indexOf('/reviews/') === 0) {
            return location.pathname === link;
        }
        if (link === '/projects') {
            return location.pathname === '/projects' || location.pathname.indexOf('/projects/group/') === 0;
        }
        if (link === '/projects/mine') {
            return location.pathname === '/projects/mine' || location.pathname.indexOf('/projects/mine/group/') === 0;
        }
        if (link === '/projects/participating') {
            return location.pathname === '/projects/participating' || location.pathname.indexOf('/projects/participating/group/') === 0;
        }
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        const stateClass = this.isActive(link)
            ? 'bg-cyan-400 text-slate-950 shadow-sm'
            : 'text-slate-300 hover:bg-slate-800 hover:text-white';

        if (this.collapsed) {
            return `group flex h-9 w-9 items-center justify-center rounded-md text-[13px] font-medium transition-colors ${stateClass}`;
        }
        return `group flex gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium transition-colors ${stateClass}`;
    }

    public headerClass() {
        if (this.collapsed) {
            return 'flex shrink-0 items-center justify-center px-1 pt-4 pb-3';
        }
        if (this.collapsible) {
            return 'flex shrink-0 items-center justify-center px-1 pt-5 pb-4';
        }
        return 'flex shrink-0 items-center justify-center pt-5 pb-4';
    }

    public navClass() {
        return 'flex flex-1 flex-col overflow-y-auto overflow-x-hidden';
    }

    public sidebarListClass() {
        if (this.collapsed) {
            return 'flex flex-1 flex-col items-center mx-0 w-full';
        }
        return 'flex flex-1 flex-col gap-y-4 mx-2';
    }

    public navSectionClass(first: boolean = false) {
        if (this.collapsed) {
            const dividerClass = first ? '' : 'mt-3 border-t border-slate-700 pt-3';
            return `flex w-full justify-center ${dividerClass}`.trim();
        }
        return '';
    }

    public sectionMenuClass() {
        return this.collapsed ? 'space-y-1' : 'mt-1 space-y-0.5';
    }

    public adminSectionClass() {
        if (this.collapsed) {
            return 'flex w-full justify-center border-t border-slate-700 pt-3';
        }
        return 'border-t border-slate-700 pt-3';
    }

    public utilitySectionClass() {
        if (this.collapsed) {
            return 'mt-auto flex w-full justify-center border-t border-slate-700 pt-3';
        }
        return 'mt-auto border-t border-slate-700 pt-3';
    }

    public utilityControlsClass() {
        if (this.collapsed) {
            return 'flex flex-col items-center gap-2';
        }
        return 'flex flex-col gap-1';
    }

    public utilityButtonClass() {
        if (this.collapsed) {
            return 'inline-flex h-9 w-9 items-center justify-center rounded-md text-slate-300 transition-colors hover:bg-slate-800 hover:text-white';
        }
        return 'inline-flex h-8 items-center gap-2 rounded-md px-2 text-[12px] font-semibold text-slate-300 transition-colors hover:bg-slate-800 hover:text-white';
    }

    public collapseButtonLabel() {
        return this.collapsed ? '사이드바 표시' : '사이드바 숨기기';
    }

    public tabsToggleLabel() {
        return this.tabsHidden ? '탭 표시' : '탭 숨기기';
    }

    public async toggleCollapse(event?: Event) {
        if (event) event.stopPropagation();
        this.toggleSidebar.emit();
        await this.service.render();
    }

    public async toggleTabsVisibility(event?: Event) {
        if (event) event.stopPropagation();
        this.toggleTabs.emit();
        await this.service.render();
    }

    public async handleCollapsedTooltipEnter(event: Event) {
        if (!this.collapsed) return;
        const target = this.collapsedTooltipTargetFromEvent(event);
        if (!target) return;
        const label = this.collapsedTooltipLabel(target);
        if (!label) return;
        if (this.collapsedTooltipTarget === target && this.collapsedTooltip.visible && this.collapsedTooltip.label === label) return;

        const rect = target.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        this.collapsedTooltipTarget = target;
        this.collapsedTooltip = {
            visible: true,
            label,
            top: Math.round(Math.max(16, Math.min(rect.top + rect.height / 2, viewportHeight - 16))),
            left: Math.round(rect.right + 10)
        };
        await this.service.render();
    }

    public async handleCollapsedTooltipLeave(event: MouseEvent | FocusEvent) {
        if (!this.collapsedTooltipTarget) return;
        const relatedTarget = event.relatedTarget as Node | null;
        if (relatedTarget && this.collapsedTooltipTarget.contains(relatedTarget)) return;

        this.collapsedTooltipTarget = null;
        this.collapsedTooltip = {
            visible: false,
            label: '',
            top: 0,
            left: 0
        };
        await this.service.render();
    }

    private collapsedTooltipTargetFromEvent(event: Event) {
        const rawTarget = event.target as HTMLElement | null;
        const currentTarget = event.currentTarget as HTMLElement | null;
        if (!rawTarget || !rawTarget.closest) return null;

        const target = rawTarget.closest('a, button') as HTMLElement | null;
        if (!target) return null;
        if (currentTarget && !currentTarget.contains(target)) return null;
        return target;
    }

    private collapsedTooltipLabel(target: HTMLElement) {
        return String(target.getAttribute('data-sidebar-tooltip') || target.getAttribute('aria-label') || target.getAttribute('title') || '').trim();
    }

    public userInitial() {
        return this.displayUserName().charAt(0) || '?';
    }

    public accountTooltip() {
        const name = this.displayUserName();
        const email = this.displayUserEmail();
        return email ? `${name} (${email})` : name;
    }

    public displayUserName() {
        return this.service.auth.session?.display_name || this.service.auth.session?.name || this.service.auth.session?.email || 'User';
    }

    public displayUserEmail() {
        return this.service.auth.session?.email || '';
    }

    public roleLabel() {
        const role = this.service.auth.session?.role || 'user';
        const labels: any = {
            admin: '관리자',
            internal: '내부사용자',
            user: '사용자',
            guest: '손님'
        };
        return labels[role] || role;
    }

    public showActivitySummary() {
        return this.canViewActivitySummary() && !!this.activitySummary;
    }

    public showActivitySkeleton() {
        if (this.activitySummary) return false;
        const role = this.service.auth.session?.role || '';
        return (!this.contextLoaded && (!role || this.canViewActivitySummary())) || this.activitySummaryLoading;
    }

    public canViewActivitySummary() {
        const role = this.service.auth.session?.role || '';
        return ['admin', 'internal'].includes(role);
    }

    public activityScore() {
        return Math.max(0, Math.min(100, Number(this.activitySummary && this.activitySummary.score ? this.activitySummary.score : 0)));
    }

    public activityScoreLabel() {
        return this.activityScore().toLocaleString('ko-KR', { maximumFractionDigits: 1 });
    }

    public activityScoreCompactLabel() {
        return Math.round(this.activityScore()).toLocaleString('ko-KR');
    }

    public activityScoreBarWidth() {
        return `${Math.max(4, this.activityScore())}%`;
    }

    public activityPeriodLabel() {
        const period = this.activitySummary && this.activitySummary.period ? this.activitySummary.period : {};
        return period.label || '이번 주';
    }

    public activityTotals() {
        return this.activitySummary && this.activitySummary.totals ? this.activitySummary.totals : {};
    }

    public activityMetricSummary() {
        const totals = this.activityTotals();
        return `리뷰 ${this.dashboardCount(totals.reviews)} · 작업 ${this.dashboardCount(totals.activities)} · AI ${this.dashboardCount(totals.codex_requests)}`;
    }

    public dashboardCount(value: any) {
        return Math.max(0, Number(value || 0)).toLocaleString('ko-KR');
    }

    public accountLink() {
        const tab = this.currentAccountTab() || this.savedAccountTab();
        return this.accountTabUrl(tab);
    }

    public activityDetailLink() {
        return this.accountTabUrl('activity');
    }

    public collapsedAccountLink() {
        return this.accountLink();
    }

    private currentAccountTab() {
        if (typeof location === 'undefined' || location.pathname !== '/account') return '';
        try {
            const params = new URLSearchParams(location.search || '');
            const tab = params.get('tab') || String(location.hash || '').replace('#', '');
            return this.isKnownAccountTab(tab) ? tab : '';
        } catch (e) {
            return '';
        }
    }

    private savedAccountTab() {
        try {
            const tab = window.sessionStorage.getItem(this.accountTabStorageKey) || '';
            return this.isKnownAccountTab(tab) ? tab : 'profile';
        } catch (e) {
            return 'profile';
        }
    }

    private isKnownAccountTab(tab: string) {
        return this.accountTabs.includes(String(tab || ''));
    }

    private accountTabUrl(tab: string) {
        return tab === 'profile' ? '/account' : `/account?tab=${encodeURIComponent(tab)}`;
    }

    public isAdmin() {
        return this.admin || this.service.auth.session?.role === 'admin';
    }

    public canUseProjectCatalog() {
        return this.projectCatalogBrowsable || !!this.service.auth.session?.can_browse_project_catalog;
    }

    public homeLink() {
        return '/projects/mine';
    }

}

export default ComponentNavSidebarComponent;